$(function () {
    $('#inputValidatedPhoneNumber, #selectValidatedPhoneNumber').on('change', function () {
        var $container = $(this).closest('.split-phone-number-with-validate');

        $container.nextAll('span.phonenumber-validation').remove();

        var $selectElem = $('#selectValidatedPhoneNumber');
        var $inputElem = $('#inputValidatedPhoneNumber');

        if ($selectElem.val() === '' || $inputElem.val() === '') {
            return;
        }

        var isValid = $selectElem.valid() && $inputElem.valid();

        if (isValid) {

            var phoneNumber = '+' + $selectElem.val() + $inputElem.val();

            $.ajax({
                url: '/phonenumber-validation',
                type: 'POST',
                data: { 'phoneNumber': phoneNumber },
                success: function (result) {
                    $('#hiddenPhoneValidation_IsValid').val(result.isValid);
                    $('#hiddenPhoneValidation_ValidationErrors').val(result.validationErrors);
                    $('#hiddenPhoneValidation_LineType').val(result.lineType);

                    if (!result.isValidMobile) {
                        var languageString = result.hasValidationErrors
                            ? window.LANG_PhoneNumberValidation_ValidationErrors.replace('{0}', result.validationErrors)
                            : window.LANG_PhoneNumberValidation_NotValidMobile;

                        $container.after('<span class="field-validation-error phonenumber-validation"><span class="is-invalid">' + languageString + '</span></span>');
                    }
                }
            });
        }
    });
});
